import { Pie, PieChart, ResponsiveContainer, Tooltip, Cell } from "recharts"
import { COLORS_GRAPH } from "../scripts/loadFunctions";

interface iPropsAmbienteVolume {
    data: any[]
}
export default function PieChartAmbienteVolume({ data }:iPropsAmbienteVolume) {

    function handleData(dados: any[]):any[] {
        let registros:any[] = []
        
        for (let reg of dados) {
            let origem = reg.origem

            let pesquisa = registros.filter(reg => reg.name === origem)
            let existe = pesquisa.length > 0 ? true : false

            if (!existe) {
                registros.push({
                    name: origem,
                    value: 1,
                })
            }

            if (existe) {
                let index = registros.indexOf(pesquisa[0])
                if (index < 0) {
                    continue
                }

                registros[index].value = registros[index].value + 1
            }
        }
        console.log(registros)

        return registros
    }

    interface iRenderCustomizedLabel {
        cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number, name: string
    }
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name }:iRenderCustomizedLabel) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);
    
      return (
        <text x={x} y={y} fill="black" textAnchor={x > cx! ? 'start' : 'end'} dominantBaseline="central">
          {name} {`${(percent! * 100).toFixed(0)}%`}
        </text>
      );
    };

    return (
        <div id="graph_origem">
            <ResponsiveContainer width="100%" height="100%" className="graph_backgrounds">
                <PieChart width={400} height={400}>
                    <Pie
                        dataKey="value"
                        isAnimationActive={false}
                        data={handleData(data)}
                        cx="50%"
                        cy="50%"
                        outerRadius={80}
                        fill="#8884d8"
                        label={renderCustomizedLabel}
                        labelLine={false}
                    >
                        {handleData(data).map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS_GRAPH[index % COLORS_GRAPH.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                </PieChart>
            </ResponsiveContainer>
        </div>
    )

}